{
  "decrease": "خفض {fieldLabel}",
  "increase": "زيادة {fieldLabel}",
  "numberField": "حقل رقمي"
}
